import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse } from '@angular/common/http';
import { AuthService } from './auth.service';
import { environment } from '../../environments/environment';
import * as uuid from 'uuid';
import { catchError, map, switchMap } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { ErrorDataService } from './error-data.service';
import { AppConfig } from '../shared/app-config';
import { factory } from '../shared/app-logging';
import { UserService } from './user.service';
import { BrandCode } from '../model/brandcode';


const logger = factory.getLogger('InfoPushService');

@Injectable({
  providedIn: 'root'
})
export class InfoPushService {

  constructor(private httpClient: HttpClient, private authService: AuthService, private userService: UserService) {
  }

  private static createPostBody(template_name: string,
    product_id: string,
    locale: string,
    context_data: any,
    user_id: string,
    delivery_methods: Array<string>,
    trace_id = uuid.v4(),
    brand: BrandCode = 'ENELX') {
    const created_dtm = Math.floor((new Date()).getTime() / 1000);
    const body = {
      body: {
        template_name: template_name,
        product_id: product_id,
        locale: locale,
        context_data: context_data,
        // brand,
        recipients: [{
          user_id: user_id,
          delivery_methods: delivery_methods
        }]
      },
      trace_id: trace_id,
      header: {
        id: 'preview-' + trace_id,
        data_md5: 'dataMd5',
        event_type: 'dr_preview',
        sender_service: 'content_library',
        sender_host: environment.contentLibraryUiRootUrl,
        create_dttm: created_dtm,
        expires_dttm: created_dtm + 300,
        destination_service: ['notificationService']
      }
    };
    return body;
  }

  requestPreview(template_name: string,
    product_id: string,
    locale: string,
    context_data: any,
    delivery_methods: Array<string>) {

    const urlService = AppConfig.urlPreviewInfoPush;
    let headers: HttpHeaders = new HttpHeaders();
    const enoc_session = this.authService.getToken();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Accept', 'application/json');
    headers = headers.append('enoc_session', enoc_session)


    const trace_id = uuid.v4();
    logger.debug(`requestPreview(${template_name},${product_id},${locale},${context_data},${delivery_methods}). token= ${enoc_session}, trace_id= ${trace_id}`);

    return this.userService.getUserDetails().pipe(
      switchMap((user) => {

        logger.debug(`requestPreview(${template_name},${product_id},${locale},${context_data},${delivery_methods}). token= ${enoc_session}, user_id=${user.userId} trace_id= ${trace_id}`);

        const body = InfoPushService.createPostBody(template_name, product_id, locale,
          context_data, user.userId, delivery_methods, trace_id);

        return this.httpClient.post(environment.infoPushApiBaseUrl + urlService, body, { headers: headers })
          .pipe(map(
            (response: HttpResponse<any>) => {
              logger.debug(`Preview request registered under trace_id= ${trace_id} for token= ${enoc_session}`);
              return response['data'];
            }
          ), catchError((err: Error | HttpErrorResponse) => {
            const message = `In InfoPushService.requestPreview(${template_name},${product_id},${locale},${context_data},${delivery_methods}).` +
              ` token= ${enoc_session}, trace_id= ${trace_id}, user_id=${user.userId}`;
            return throwError(ErrorDataService.overLoadError(err, message));
          }))

      })
    )



  }

}
